import IconBot from './IconBot';

const AutoConnectBot = ({ sendBotMessage }: any) => {
	return <IconBot id="bot" onClick={sendBotMessage} />;
};

export default AutoConnectBot;
